export default "__VITE_ASSET__189cdec9__"